import { lazy } from 'react';
import { adaptiveCenterModalOptions } from '../../../appComponents/ModalWrapper';
import { wrapNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const SharedReviewPageContent = lazy(() => import('./SharedReviewPageContent'));

// note: this page is intended to be opened via:
// - review sharing deep linking (android) or universe links (iOS) or
// - push notification center or in-app notification banner
export const SharedReviewPage = wrapNavigatorScreen(
  SharedReviewPageContent,
  adaptiveCenterModalOptions(),
);
